import customAxios from "../../customAxios";
import { DELETE_SERVICE_FROM_DRIVER} from "../../routes";

const deleteServiceFromDriver = async (serviceId: string) => {
  try {
    return (await customAxios.delete(DELETE_SERVICE_FROM_DRIVER + `/${serviceId}`)).data;
  } catch (error: any) {
    console.log({DELETE_DRIVER: error});
    return false;
  }
};

export default deleteServiceFromDriver;
